import { payment_links as paymentLinks } from '@repo/domain-types/cards-acceptance';

const ApiPaymentLinkStatus = paymentLinks.firstparty.v4.ApiPaymentLinkStatus;
const ApiPaymentMethod = paymentLinks.firstparty.v4.ApiPaymentMethod;
const ApiPaymentMethodStatus = paymentLinks.firstparty.v4.ApiPaymentMethodStatus;
const ApiResourceType = paymentLinks.firstparty.v4.ApiResourceType;
const ApiItemType = paymentLinks.firstparty.v4.ApiItemType;
const ApiPaymentLinkRecurrenceType = paymentLinks.firstparty.v4.ApiPaymentLinkRecurrenceType;
const ApiFrequencyRecurrence = paymentLinks.firstparty.v4.ApiFrequencyRecurrence;

export const PaymentLinkStatus = {
  Unspecified: ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_UNSPECIFIED,
  Open: ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_OPEN,
  Processing: ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PROCESSING,
  Paid: ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_PAID,
  Canceled: ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_CANCELED,
  Expired: ApiPaymentLinkStatus.PAYMENT_LINK_STATUS_EXPIRED,
} as const;

export const PaymentMethod = {
  Unspecified: ApiPaymentMethod.PAYMENT_METHOD_UNSPECIFIED,
  CreditCard: ApiPaymentMethod.PAYMENT_METHOD_CREDIT_CARD,
  ApplePay: ApiPaymentMethod.PAYMENT_METHOD_APPLE_PAY,
  Paypal: ApiPaymentMethod.PAYMENT_METHOD_PAYPAL,
  Ideal: ApiPaymentMethod.PAYMENT_METHOD_IDEAL,
  BankTransfer: ApiPaymentMethod.PAYMENT_METHOD_BANK_TRANSFER,
} as const;

export const PaymentMethodStatus = {
  Unspecified: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_UNSPECIFIED,
  Inactive: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_INACTIVE,
  Active: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_ACTIVE,
  PendingReview: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_REVIEW,
  PendingExternal: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_EXTERNAL,
  PendingOnboarding: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_PENDING_ONBOARDING,
  Rejected: ApiPaymentMethodStatus.PAYMENT_METHOD_STATUS_REJECTED,
} as const;

export const ResourceType = {
  Unspecified: ApiResourceType.RESOURCE_TYPE_UNSPECIFIED,
  Basket: ApiResourceType.RESOURCE_TYPE_BASKET,
  Invoice: ApiResourceType.RESOURCE_TYPE_INVOICE,
} as const;

export const ItemType = {
  Unspecified: ApiItemType.ITEM_TYPE_UNSPECIFIED,
  Good: ApiItemType.ITEM_TYPE_GOOD,
  Service: ApiItemType.ITEM_TYPE_SERVICE,
} as const;

export const PaymentLinkRecurrenceType = {
  Unspecified: ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED,
  OneOff: ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF,
  Recurring: ApiPaymentLinkRecurrenceType.PAYMENT_LINK_RECURRENCE_TYPE_RECURRING,
} as const;

export type PaymentLinkStatusValue = (typeof PaymentLinkStatus)[keyof typeof PaymentLinkStatus];
export type PaymentMethodValue = (typeof PaymentMethod)[keyof typeof PaymentMethod];
export type PaymentMethodStatusValue =
  (typeof PaymentMethodStatus)[keyof typeof PaymentMethodStatus];
export type ResourceTypeValue = (typeof ResourceType)[keyof typeof ResourceType];
export type ItemTypeValue = (typeof ItemType)[keyof typeof ItemType];
export type PaymentLinkRecurrenceTypeValue =
  (typeof PaymentLinkRecurrenceType)[keyof typeof PaymentLinkRecurrenceType];

export const PaymentLinkRecurrenceFrequency = {
  Unspecified: ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_UNSPECIFIED,
  Weekly: ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_WEEKLY,
  Monthly: ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_MONTHLY,
  Quarterly: ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_QUARTERLY,
  Semesterly: ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_SEMESTERLY,
  Yearly: ApiFrequencyRecurrence.FREQUENCY_RECURRENCE_YEARLY,
} as const;

export type PaymentLinkRecurrenceFrequencyValue =
  (typeof PaymentLinkRecurrenceFrequency)[keyof typeof PaymentLinkRecurrenceFrequency];
